!function () {
  "use strict";

  class CartBar extends HTMLElement {
    constructor() {
      super();
      this.section = this.closest("product-info");
      this.form = this.section.querySelector("[data-product-form]");
      this.formWrapper =
        (theme.settings.productPageSticky && this.section.querySelector("[data-form-wrapper]")) ||
        this.form;
      this.handleProductAddError = this.handleProductAddError.bind(this);
      this.boundToggleCartBarOnScroll = this.toggleCartBarOnScroll.bind(this);
      this.boundSetCartBarHeight = this.setCartBarHeight.bind(this);
    }

    connectedCallback() {
      this.setCartBarHeight();
      this.addEventListener("click", this.handleClick.bind(this));
      document.addEventListener("theme:scroll", this.boundToggleCartBarOnScroll);
      document.addEventListener("theme:resize", this.boundSetCartBarHeight);
      document.addEventListener("theme:product:add-error", this.handleProductAddError);
    }

    handleClick(e) {
      const addToCartBtn = e.target.closest("[data-cart-bar-add-to-cart]");

      if (addToCartBtn) {
        e.preventDefault();
        addToCartBtn.classList.add("is-loading");
        addToCartBtn.setAttribute("disabled", "disabled");
        this.form.querySelector("[data-add-to-cart]").click();
        return;
      }

      if (e.target.closest("[data-cart-bar-scroll]")) {
        e.preventDefault();
        this.scrollToTop();
      }
    }

    handleProductAddError() {
      if (this.querySelector("[data-cart-bar-add-to-cart]")) {
        this.scrollToTop();
      }
    }

    scrollToTop() {
      const variantSelects = this.section.querySelector("variant-selects");
      const scrollTarget = window.theme.isMobile() ? variantSelects || this.form : this.section;
      const top = scrollTarget.getBoundingClientRect().top;
      window.theme.scrollTo(window.theme.isMobile() ? top - 10 : top);
    }

    toggleCartBarOnScroll() {
      const scrollY = window.scrollY;
      if (this.formWrapper) {
        const pastForm = scrollY > this.formWrapper.offsetTop + this.formWrapper.offsetHeight;
        this.classList.toggle("is-visible", pastForm);
      }
    }

    setCartBarHeight() {
      const height = this.offsetHeight;
      document.documentElement.style.setProperty("--cart-bar-height", `${height}px`);
    }

    disconnectedCallback() {
      document.removeEventListener("theme:product:add-error", this.handleProductAddError);
      document.removeEventListener("theme:scroll", this.boundToggleCartBarOnScroll);
      document.removeEventListener("theme:resize", this.boundSetCartBarHeight);
    }
  }

  customElements.get("cart-bar") || customElements.define("cart-bar", CartBar);
}();
